import { useContext, useEffect, useMemo, useState } from 'react';
import ReactModal from 'react-modal';
import { useNavigate } from 'react-router';
import { IoIosClose } from 'react-icons/io';

import Button from 'components/ui/button';
import { ModalContext } from 'context/ModalContext';
import { getStorageItem, setStorageItem } from 'utils/storage';
import { getTasksOtherIndicator } from 'services/dashboard.service';

interface TaskOtherIndicationProps {
  /** Sinal para a fila de modais do Dashboard (pages/Dashboard/modal-queue.ts):
   *  dispara quando esta modal esta RESOLVIDA — sem tarefas para mostrar, ou fechada
   *  pelo usuario. Opcional e backward-safe: quem nao passa nada nao muda em nada. */
  onSettled?: () => void;
}

export function TaskOtherIndication({ onSettled }: TaskOtherIndicationProps = {}) {
  const navigate = useNavigate();

  const modalID = 'task-other-indication-modal';

  const { openModal, closeModal } = useContext(ModalContext);
  const [modalIsOpen, setIsOpen] = useState(false);

  const [tasks, setTasks] = useState<{ _id: string; fase: number }[]>([]);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  useEffect(() => {
    async function loadData() {
      const tasks = await getTasksOtherIndicator();
      setTasks(tasks);

      if (tasks && tasks.length > 0) {
        setIsOpen(true);
      } else {
        onSettled?.();
      }
    }

    loadData();
    // `onSettled` fica fora das deps de propósito: o Dashboard o passa inline (função
    // nova a cada render) e incluí-lo faria a busca de tarefas repetir a cada render.
    // A carga é de montagem única — o sinal usa a referência corrente na resolução.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!Array.isArray(tasks) || !tasks?.length) {
    return <></>;
  }

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Example Modal"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
        contentElement={() => (
          <div>
            <div className="bg-oxford-blue relative ring-2 ring-electric-blue text-white rounded-xl py-8 px-16 block space-y-8 max-w-[576px]">
              <Button
                color="primary"
                className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
                onClick={() => [setIsOpen(false), onSettled?.()]}
              >
                <IoIosClose color="white" size={30} />
              </Button>

              <h2 className="text-yellow text-lg block text-center !m-0 tracking-tight">Atualizar Indicador de Realizações</h2>
              <p className="m-0 p-0 text-base block font-thin tracking-tight">
                Você possui realizações com Indicador definido como "Outros". Edite e altere o indicador para o mais adequado a
                sua realização.
              </p>

              {/* <p className="m-0 p-0 text-base block font-thin tracking-tight">
                OBS.: Caso queira autorizar a participação depois, basta acessar a página{' '}
                <strong>Minha equipe {'>'} Avaliar número de participantes em realização</strong>. Lá você encontrará o card da
                realização sinalizado pelo status e pronto para autorizar ou recusar a quantidade de participantes na realização.
              </p> */}
              <div className="flex justify-center">
                <Button
                  className="!py-2 !px-3 !text-sm !uppercase !leading-none"
                  onClick={() => [navigate(`/realizacao-destaque?fase=${tasks[0].fase}`), setIsOpen(false), onSettled?.()]}
                >
                  VER REALIZAÇÃO
                </Button>
              </div>
            </div>
          </div>
        )}
      />
    </>
  );
}
